import InputWrapper from "../InputWrapper/InputWrapper";

import styles from "./Select.module.scss";

export default function Select({
  id,
  label,
  options,
  register = (name, options) => {
    return;
  },
  formState,
  wrapperProps,
  attributes,
  onChange,
  value,
  defaultValue,
  controlled = true,
}) {
  const optionElements = options.map((option, index) => (
    <option
      className={`selectOption`}
      value={option.value}
      key={`${option.value}-${index}`}
    >
      {option?.label ?? option.value}
    </option>
  ));

  const conditionalProps = {};

  if (!!onChange) {
    conditionalProps.onChange = onChange;
  }

  if (!!value) {
    conditionalProps.value = value;
  }

  if (!!defaultValue) {
    conditionalProps.defaultValue = defaultValue;
  }

  const selectElement = (
    <select
      {...register(id)}
      className={`select ${styles.select}`}
      {...conditionalProps}
    >
      {optionElements}
    </select>
  );

  if (controlled) {
    return (
      <InputWrapper
        label={label}
        id={id}
        formState={formState}
        {...wrapperProps}
        controlled={controlled}
      >
        {selectElement}
      </InputWrapper>
    );
  }

  return selectElement;
}
